import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { ConnectOverviewPage } from "@/modules/connect/OverviewPage";
import { ConnectCostsPage, ConnectInventoryPage, ConnectOnboardingPage } from "@/modules/connect/pages";
import { ScopeSelect } from "@/modules/connect/scope";

export function ConnectModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/connect"
          tabs={[
            { path: "overview", label: "Overview" },
            { path: "onboarding", label: "Onboarding" },
            { path: "inventory", label: "Inventory" },
            { path: "costs", label: "Costs & Plans" },
          ]}
        />
        <div style={{ marginLeft: "auto", paddingBottom: 9, paddingRight: 20 }}>
          <ScopeSelect />
        </div>
      </div>
      <Routes>
        <Route path="overview" element={<ConnectOverviewPage />} />
        <Route path="onboarding" element={<ConnectOnboardingPage />} />
        <Route path="inventory" element={<ConnectInventoryPage />} />
        <Route path="costs" element={<ConnectCostsPage />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
